module.exports = __webpack_public_path__ + "img/popup-top-icon.f5d1ec6.png";